import {ActionBuilder} from "co-redux-builders";

export default ActionBuilder.build({
    toggleSideBar: () => ({}),
    onSetSideBar: (open: boolean) => ({open}),
    onChangeMediaQuery: (mediaQueryList: MediaQueryList) => ({mediaQueryList}),
});